import Typography from "@@/elements/Typography";
import cn from "classnames";
import { SecondaryButtonProps } from "./buttonProps";
import styles from "./buttonStyles.module.scss";
import { formatLinkContent } from "./utils";

const SecondaryButton = ({
  disabled,
  onClick,
  label,
  color = "charcoal",
  href,
  target = "_self",
  title,
  externalLinkText,
}: SecondaryButtonProps) => {
  const classNames = cn(styles.base_button, styles.secondary, {
    [(styles as any)[`secondary_${color}`]]: color,
  });

  if (href) {
    return (
      <a href={href} className={classNames} title={title} target={target}>
          {formatLinkContent(href, label, target, externalLinkText, color === "white" ? "dark" : "light")}
      </a>
    );
  }
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={classNames}
      type="button"
    >
      <Typography variant="button" asElement="span">{label}</Typography>
    </button>
  );
};
export default SecondaryButton;
